import { hydrate } from 'svelte'

import createClinicalStores from '../stores/createClinicalStores'

import AnimatedValue from '../../components/projects/facts-and-figures/core/dataviz/AnimatedValue.svelte'
import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import DecorativeHorizontalBars from '../../components/projects/facts-and-figures/composite/DecorativeHorizontalBars.svelte'
import LabelValueParagraph from '../../components/projects/facts-and-figures/core/visual/LabelValueParagraph.svelte'
import OpenBottomDonut from '../../components/projects/facts-and-figures/composite/OpenBottomDonut.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'
import StandardDonut from '../../components/projects/facts-and-figures/composite/StandardDonut.svelte'
import ThreeColList from '../../components/projects/facts-and-figures/core/ThreeColList.svelte'
import GenericDonut from '../../components/projects/facts-and-figures/highcharts/GenericDonut.svelte'
import PressGaneyDounut from '../../components/projects/facts-and-figures/composite/PressGaneyDonut.svelte'
import Ghost from '../../components/lib/Ghost.svelte'


/**
 * Fetch data for clinical; Mount home components with data
 */
export default function () {
	const [
		data,
		loading,
		error,

		outpatientDerived,
		rateproviderDerived,
		specialtiesDerived,
		totalAnnualDerived,
		clinicalpieDerived,
	] = createClinicalStores()

	if (document.getElementById('totleSpec')) {
		hydrate(DecorativeDonut, {
			target: document.getElementById('totleSpec'),
			props: {
				store: specialtiesDerived,
				label: 'Total number of Specialties'
			}
		})
	}

	if(document.getElementById('rateProvider')) {
		hydrate(PressGaneyDounut, {
			target: document.getElementById('rateProvider'),
		})
  }

	if (document.getElementById('outpatient')) {
		hydrate(DecorativeDonut, {
			target: document.getElementById('outpatient'),
			props: {
				store: totalAnnualDerived,
				//max: '2,487',
			}
		})
	}

	if (document.getElementById('visits')) {
		hydrate(DecorativeDonut, {
			target: document.getElementById('visits'),
			props: {
				store: outpatientDerived,
				//max: '2,487',
				label: 'Total Annual Visits'
			}
		})
	}

	if (document.getElementById('ghost-gen')) {
		hydrate(Ghost, {
			target: document.getElementById('ghost-gen'),
			props: {
				store: clinicalpieDerived,
				dataFunction: (dataArray) => {
					let valueSum = 0

					dataArray.forEach((item, index) => {
						valueSum += parseInt(item[1])
					})

					dataArray.forEach((item, index) => {
						$("#totalVisits").append('<div tab-index="0" class="clinical-bar' + index + ' ' + item[0].toLowerCase().replace(/\s+/g, '').replace(/[0-9]/g, '') + ' " style=" max-width:' + parseInt((item[1] / valueSum) * 100) + '%;"> <span>' + parseInt(item[1]).toLocaleString("en-US") + '</span></div>')
					})

					dataArray.forEach((item, index) => {
						$("#totalVisits").append('<p class="clinical-bar-link ' + item[0].toLowerCase().replace(/\s+/g, '').replace(/[0-9]/g, '') + '" style=" max-width:' + parseInt((item[1] / valueSum) * 100) + '%;"> <span class="label">' + item[0].replace(/[0-9]/g, '') + ' </span></p>')
					})
				}
			}
		})
	}
}